import modules from '@/sui/data/modules'
import stringify from 'csv-stringify'

export default function (filename, vm, surveillances, type, year, list, save, error) {
  const module = modules[year][type]
  if (module == null) {
    error(`Unknown module ${type} in year ${year}`)
  }

  const sortedSurveillances = surveillances.slice().sort((f, s) => f.id.localeCompare(s.id))
  const sorted = list.slice().sort((f, s) => f.sv.localeCompare(s.sv))
  const reducer = (result, s) => {
    if (result.cache[s.sv] == null) {
      result.cache[s.sv] = true
      result.list.push(s.sv)
    }
    return result
  }
  const ids = sorted.reduce(reducer, { cache: {}, list: [] })
  vm.$store.dispatch('singlesheets/allDenominators', { s: ids.list }).then(
    (r) => {
      if (r.data.err != null) {
        vm.setError(r.data.err)
        return r
      }
      const denominators = r.data.v
      denominators.sort((f, s) => f.sv.localeCompare(s.sv))

      const values = module.sheets.flatten(
        {
          type: type,
          treeFields: module.sheets.edit.fields,
          sheets: sorted,
          onlyClosed: false,
          surveillances: sortedSurveillances,
          denominators: denominators,
          removeEmptyColumns: module.removeEmptyColumns
        }
      )

      stringify(
        values.sheets,
        values.options,
        (err, output) => {
          if (err == null) {
            setTimeout(
              () => save(
                {
                  filename: filename,
                  blob: new Blob([output], { type: 'text/plain' })
                }
              ), 10
            )
          } else {
            error(err)
          }
        }
      )
      return r
    }
  ).catch(e => { error(e) })
}
